import { Show } from 'solid-js';
import { SITE } from '../../config/site';
import { PixelIcon } from '../PixelIcon';

interface WelcomeWindowProps {
  projectCount: number;
  registrySource: 'remote' | 'fallback';
  registryWarning?: string;
  registryLoading: boolean;
  openProjects: () => void;
  openAbout: () => void;
  openStory: () => void;
}

export function WelcomeWindow(props: WelcomeWindowProps) {
  return (
    <div class="window-body app-window-body welcome-window">
      <div class="welcome-heading">
        <PixelIcon name="computer" size={48} />
        <div>
          <h1>{SITE.welcome.heading}</h1>
          <p>{SITE.welcome.lead}</p>
        </div>
      </div>

      <fieldset>
        <legend>Where would you like to go?</legend>
        <div class="welcome-actions">
          <button class="default" onClick={props.openProjects}>Explore runnable projects</button>
          <button onClick={props.openAbout}>About Ivan</button>
          <button onClick={props.openStory}>Read my story</button>
        </div>
      </fieldset>

      <div class="sunken-panel welcome-system-panel">
        <dl>
          <div><dt>Published projects</dt><dd>{props.projectCount}</dd></div>
          <div><dt>Project catalog</dt><dd>{props.registryLoading ? 'Checking live registry…' : props.registrySource === 'remote' ? 'Live R2 registry' : 'Built-in fallback'}</dd></div>
          <div><dt>Interface</dt><dd>98.css + SolidJS</dd></div>
          <div><dt>Location</dt><dd>{SITE.location}</dd></div>
        </dl>
      </div>

      <Show when={props.registryWarning}>
        <div class="inline-notice" role="status">
          <PixelIcon name="warning" size={22} />
          <span>{props.registryWarning}</span>
        </div>
      </Show>

      <p class="welcome-tip"><strong>Tip:</strong> double-click a desktop icon, or use the Start menu. Project URLs such as <code>/projects/raytracer</code> can be shared directly.</p>
    </div>
  );
}
